import React from 'react';
import { connect } from 'react-redux';
import { Col } from 'reactstrap';

import Reviews from './Reviews';
import Loading from '../Loading';

function SideBarReviews({ reviews, isMobile, ratings }) {
  return (
    <Col className={isMobile ? 'd-block d-lg-none px-0':'d-none d-lg-block col-lg-4'}>
      <div className="white-panel review-container">
        <h2 style={{ lineHeight: '30px' }}>
          Recent Reviews
          <span className="float-right">
            <a href={isMobile ? "#full-reviews-mobile" : "#full-reviews"} style={{ color: '#e91e63', fontWeight: '700'}}>See All</a>
          </span>
        </h2>
        <ul className="list-comments">
          {}
          {(reviews &&
            reviews.length > 0) ?
            reviews.slice(0, 3).map(review => {
              const reviewHasAuthor = Boolean(review.author);
              if (reviewHasAuthor)
              return (
                <Reviews
                  key={review.id}
                  review={review}
                />
              );
              return null;
            }) : <Loading /> }
          </ul>
      </div>
    </Col>
  );
}

const mapStateToProps = state => ({
  reviews: state.reviewsState.reviews,
});

export default connect(mapStateToProps)(SideBarReviews);



// WEBPACK FOOTER //
// ./src/components/ReviewsRatings/SideBarReviews.js